import { Card, Center, Space } from '@mantine/core';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import GridCell from '../../components/elements/GridCell';
import Tab from '../../components/elements/Tab';
import EditBankForm from '../../components/forms/EditBankForm';
import EditMerchantForm from '../../components/forms/EditMerchantForm';
import ModalSettingMerchant from '../../components/fragments/ModalSettingMerchant';
import { AppContext } from '../../contexts';
import { editFormPayload } from '../../utils/builder/settingDataMerchant';
import {
  fetchSettingMerchantDetail,
  setFormAction,
  setMessageAction,
  updateMerchant,
} from './actions';
import styles from './styles.scoped.css';
import EditMIDForm from '../../components/forms/EditMIDForm';

function EditMerchant() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { setBreadcrumbs } = useContext(AppContext);
  const dispatch = useDispatch();
  const {
    detail: { data },
    edit: { success, message, form: changedValues },
    bank,
  } = useSelector((state) => state.merchantSetting);
  const form = useSelector((state) => state.form);

  const [openModal, setOpenModal] = useState(false);
  const [tabItem, setTabItem] = useState('data');

  const tabList = useMemo(() => {
    const disabled =
      data.isActiveMyptm &&
      bank.data.isChecked !== undefined &&
      !bank.data.isValid;

    const result = [
      { label: 'Data Pangkalan LPG 3 Kg', value: 'data', disabled },
      { label: 'Rekening Bank', value: 'bank' },
      { label: 'MID LinkAja', value: 'mid', disabled },
    ];
    if (!data.isActiveMyptm) {
      result.pop();
      result.pop();
    }
    return result;
  }, [data.isActiveMyptm, bank.data]);

  const handleChangeTab = (val) => {
    setTabItem(val);
  };
  const handleOpenModal = () => {
    setOpenModal(true);
    dispatch(setMessageAction({ key: 'edit', message: '' }));
  };
  const handleCloseModal = () => setOpenModal(false);
  const handleSubmitForm = () => {
    const formEdit = form?.formEditMerchant;
    const payload = editFormPayload(
      changedValues || { ...formEdit?.values, ...formEdit?.values?.bank }
    );
    // const payload = editFormPayload(values);
    dispatch(updateMerchant({ id, payload }));
  };

  useEffect(() => {
    setBreadcrumbs([
      { name: 'Data Pangkalan LPG 3 Kg', to: '/merchant/setting-data-merchant/'	},
      'Ubah']);
    dispatch(fetchSettingMerchantDetail(id, true));
    dispatch(setMessageAction({ key: 'edit', message: '' }));
  }, []);

  useEffect(() => {
    if (success) {
      dispatch(setFormAction({ key: 'edit', form: null }));
      navigate(`/merchant/setting-data-merchant/detail/${id}`);
    }
    if (message) {
      handleCloseModal();
    }
  }, [success, message]);

  return (
    <main className={styles.rootEdit}>
      <Card py={0} radius="md" withBorder>
        <h5>Ubah Data Pangkalan LPG 3 Kg</h5>
      </Card>
      <Tab data={tabList} defaultValue={tabItem} onChange={handleChangeTab} />
      <Card radius="md" withBorder>
        <Center>
          <div style={{ width: '80%' }}>
            <div style={{ width: '70%' }}>
              <GridCell data={data.midMap} label="MID" />
              <Space h="xs" />
              <GridCell
                data={`${data.agen?.id || ''} - ${data.agen?.name || ''}`}
                label="ID Agen"
              />
            </div>
            {tabItem === 'data' && (
              <EditMerchantForm
                handleOpenModal={handleOpenModal}
                initialValues={changedValues || data}
              />
            )}
            {tabItem === 'bank' && (
              <EditBankForm
                handleOpenModal={handleOpenModal}
                initialValues={changedValues || data?.bank}
              />
            )}
            {tabItem === 'mid' && (
              <EditMIDForm
                handleOpenModal={handleOpenModal}
                initialValues={changedValues || { midLA: data?.midLA }}
              />
            )}
          </div>
        </Center>
      </Card>
      <ModalSettingMerchant
        handleSubmit={handleSubmitForm}
        merchantName={data.storeName}
        onClose={handleCloseModal}
        open={openModal}
        type="edit-merchant"
      />
    </main>
  );
}

export default EditMerchant;
